import { useCallback } from "react";
import { setShowModalSelectSubscription } from "../actions/ui";
import { useDispatchApp, useSelectorApp } from "../lib/redux";

const selectIsSubscriptionPaywallActive = (state) => {
  const isPaywallOpen = Boolean(state.ui.showModalSelectSubscription);
  const isPlanInactive =
    state.payments.isPlanActiveResolved && !state.payments.isPlanActive;

  return isPaywallOpen || isPlanInactive;
};

const useIsSubscriptionPaywallActive = () => {
  return useSelectorApp(selectIsSubscriptionPaywallActive);
};

export const useBlockIfSubscriptionPaywall = () => {
  const dispatch = useDispatchApp();
  const isPaywallActive = useIsSubscriptionPaywallActive();
  const isPaywallOpen = useSelectorApp((state) =>
    Boolean(state.ui.showModalSelectSubscription)
  );

  return useCallback(() => {
    if (!isPaywallActive) {
      return false;
    }

    if (!isPaywallOpen) {
      dispatch(setShowModalSelectSubscription(true));
    }

    return true;
  }, [dispatch, isPaywallActive, isPaywallOpen]);
};

export default useIsSubscriptionPaywallActive;
